module.exports = __webpack_public_path__ + "img/introduce1.e6f2482c.png";